import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { QuicksightService } from 'src/app/core/services/quicksight/quicsight.service'; 

declare global {
  interface Window {
    QuickSightEmbedding: any;
  }
}

@Component({
  selector: 'app-quicksight-dashboard',
  templateUrl:'./quicsight-dashboard.component.html',
  styles: [`
    .dashboard-container {
      width: 100%;
      height: 800px;
    }
  `]
})
export class QuicsightDashboardComponent implements OnInit {
  @Input() reportType:string;
  @ViewChild('dashboardContainer') dashboardContainer: ElementRef;
  dashboardURL: string;

  constructor(private quicksightService: QuicksightService,) {}

  async ngOnInit() {
    if (this.reportType) {
      this.dashboardURL = this.reportType;
      this.loadDashboard();
    } else {
      console.error('No function provided to get the dashboard embed URL.');
    }
  }


  getData(){
    this.quicksightService.getDashboardEmbedURLMONGO()
    .subscribe((res)=>{
      console.log(res);
    })  
  }

  private async loadDashboard() {
    this.quicksightService.getDashboardEmbedURLMONGO()
      .subscribe(
          response => {
              this.embedDashboard(response?.data?.embedUrl);
              // Set up refresh before URL expires
              const refreshTime = new Date(response?.expiresIn).getTime() - new Date().getTime() - 300000; // 5 minutes before expiry
              // setTimeout(() => this.loadDashboard(), refreshTime);
          },
          error => {
              console.error('Failed to load dashboard:', error);
          }
      );
  }


  private embedDashboard(embedUrl: string) {
    const options = {
        url: embedUrl,
        container: this.dashboardContainer.nativeElement,
        scrolling: "no",
        height: "800px",
        width: "100%",
        footerPaddingEnabled: true,
        loadingHeight: "800px",
        errorCallback: (error: any) => {
          console.error('QuickSight embedding error:', error);
          if (error.message.includes('invalid URL or authorization code')) {
              this.loadDashboard(); // Retry loading with new URL
          }
        }
    };
    window.QuickSightEmbedding.embedDashboard(options);
  }
}